import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { OccupancyYearlyReportResponseV4Schema } from "../response/OccupancyYearlyReportResponseV4";
import { OccupancyYearlyReportFilterV4Type } from "../schema/OccupancyYearlyReportFilterSchemaV4";

const API_VERSION = 'v4';

interface OccupancyYearlyReportV4Props {
    filter?: OccupancyYearlyReportFilterV4Type;
    type: string | null;
    group_by?: string;
}

const useOccupancyYearlyReportV4 = (params: OccupancyYearlyReportV4Props) => {
    return useQuery({
        queryKey: [
            'report',
            'group-occupancy-yearly',
            API_VERSION,
            params.type,
            JSON.stringify(params.filter),
            params.group_by,
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/channel-manager/group-report-occupancy-yearly`, {
                    params: {
                        filter: {
                            ...params.filter,
                        },
                        group_by: params.group_by,
                    }
                });

                const validationResult = OccupancyYearlyReportResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Occupancy Yearly report V4 data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Occupancy Yearly report V4`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_ids && !!params.filter.start_date && !!params.filter.end_date && params.type === "occupancy_report" && !!params.group_by,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useOccupancyYearlyReportV4;